import { apiClient } from './client'
import type {
  HandleAvailability,
  Me,
  PublicProfile,
  SubscribedCreator,
  UpdateProfileRequest,
} from './types'

export const updateMyProfile = async (req: UpdateProfileRequest): Promise<Me> => {
  const response = await apiClient.patch<Me>('/api/v1/me/profile', req)
  return response.data
}

export const checkHandleAvailability = async (handle: string): Promise<HandleAvailability> => {
  const response = await apiClient.get<HandleAvailability>(
    '/api/v1/me/profile/handle-availability',
    { params: { handle } }
  )
  return response.data
}

export const fetchPublicProfile = async (handle: string): Promise<PublicProfile> => {
  const response = await apiClient.get<PublicProfile>(`/api/v1/users/${encodeURIComponent(handle)}`)
  return response.data
}

export const subscribeToCreator = async (handle: string): Promise<void> => {
  await apiClient.post(`/api/v1/users/${encodeURIComponent(handle)}/subscribe`)
}

export const unsubscribeFromCreator = async (handle: string): Promise<void> => {
  await apiClient.delete(`/api/v1/users/${encodeURIComponent(handle)}/subscribe`)
}

export const fetchMySubscriptions = async (): Promise<SubscribedCreator[]> => {
  const response = await apiClient.get<SubscribedCreator[]>('/api/v1/me/subscriptions')
  return response.data
}

/**
 * Phase 7: upload a cropped Avatar image. {@code blob} is the canvas-cropped square output from
 * {@code AvatarCropDialog}; the backend handles resize-to-256 + WebP encode + EXIF strip + magic-
 * byte validation server-side. Returns the updated Me with the new {@code avatarUrl}.
 */
export const uploadAvatar = async (blob: Blob): Promise<Me> => {
  const form = new FormData()
  // Filename is informational; the backend trusts magic-byte detection over Content-Type or name.
  form.append('file', blob, 'avatar.png')
  const response = await apiClient.post<Me>('/api/v1/me/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

/** Phase 7: revert to Default Avatar. Idempotent on the server. */
export const deleteAvatar = async (): Promise<Me> => {
  const response = await apiClient.delete<Me>('/api/v1/me/avatar')
  return response.data
}
